export const LOCALES = {
  ENGLISH: 'en-us',
  HEBREW: 'he-he'
}
